import LeftSide from "../Components/AiComponents/modules/aboutChatbot/LeftSide";
import RightSide from "../Components/AiComponents/modules/aboutChatbot/RightSide";
import LandingLayout from "../layouts/LandingLayout";

function AboutChatbot() {
  return (
    <>
      <LandingLayout className="bg-black">
        <div className="w-full flex px-5 justify-between mt-16">
            <LeftSide />
            <RightSide />
        </div>
      </LandingLayout>
    </>
  );
}

export default AboutChatbot;
